import { dateToApiFormat } from '../../../helpers/dateHelper';
import { useGetRosterStatusesQuery } from '../../../services/gql/graphql.generated';
import { useDaysInMonth } from '../../../services/settings/useDates';
import { SummaryEmployee } from "../../../services/summary/summary.types";

export const useRosterStatuses = (date: Date, selectedLocationId: number, summary: SummaryEmployee[]) => {
  const employeesFromOtherShops = summary.filter(e => !!e.details.homeLocationId && e.details.homeLocationId !== selectedLocationId);
  const otherLocationIds: number[] = [];
  employeesFromOtherShops.forEach(e => {
    if (!otherLocationIds.find(id => e.details.homeLocationId === id)) {
      otherLocationIds.push(e.details.homeLocationId!);
    }
  });

  const daysInMonth = useDaysInMonth(date);

  const [{ data }] = useGetRosterStatusesQuery({
    variables: {
      dateRangeAndLocations: {
        start: dateToApiFormat(daysInMonth[0]),
        end: dateToApiFormat(daysInMonth[daysInMonth.length - 1]),
        locationIds: otherLocationIds
      }
    },
    requestPolicy: 'cache-and-network'
  });

  return data?.rosterStatuses;
};
